import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import salesCosts, { salesCostsSaga } from './salesCosts';

const salesCostModule = combineReducers({
  salesCosts,
});

export function* salesCostModuleSaga() {
  yield all([salesCostsSaga()]);
}

export default salesCostModule;
